<script setup>
// Addendum §2.4 MenuButton — ONE button; the whole surface opens the menu.
// aria-haspopup="menu" + aria-expanded are supplied by the trigger here.
import LDropdownMenu from './DropdownMenu.vue'
import LIcon from '../base/Icon.vue'

defineProps({
  label: { type: String, required: true },
  items: { type: Array, default: () => [] },
  variant: { type: String, default: 'secondary' }, // secondary | quiet
  align: { type: String, default: 'start' },
})
</script>

<template>
  <LDropdownMenu :items="items" :align="align">
    <template #trigger="{ toggle, open, onkeydown }">
      <button
        type="button"
        class="menu-trigger"
        :class="[`is-${variant}`, { open }]"
        aria-haspopup="menu"
        :aria-expanded="open"
        @click="toggle"
        @keydown="onkeydown"
      >
        <slot name="icon" />
        <span>{{ label }}</span>
        <LIcon name="chevron-down" :size="13" class="caret" />
      </button>
    </template>
  </LDropdownMenu>
</template>

<style scoped>
.menu-trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-ui);
  font-size: var(--text-sm);
  font-weight: 600;
  min-height: 36px;
  padding: 9px 14px;
  border-radius: var(--r);
  border: 1px solid transparent;
}
.is-secondary {
  background: var(--surface);
  border-color: var(--line);
  color: var(--text-2);
}
.is-secondary:hover,
.is-secondary.open {
  background: var(--surface-sunken);
  color: var(--text);
}
.is-quiet {
  background: transparent;
  color: var(--text-2);
}
.is-quiet:hover,
.is-quiet.open {
  background: var(--surface-sunken);
  color: var(--text);
}
.caret {
  color: var(--icon);
  transition: transform var(--t-fast) var(--ease);
}
.open .caret {
  transform: rotate(180deg);
}
</style>
